import {
  RefreshTokenError,
  useApiMutation as useApiMutationBase
} from '@legit-health/backend-client';

type Props<TData> = Parameters<typeof useApiMutationBase<TData>>[0];

export default function useApiMutation<TData>(props?: Props<TData>) {
  return useApiMutationBase<TData>({
    options: {
      ...(props?.options ?? {}),
      throwOnError: (error) => error instanceof RefreshTokenError
    }
  });
}
